import "@/App.css";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const IMG_FRONT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_badge-simulator-1/artifacts/a4328fd74f844fea_WhatsApp%20Image%202026-10-18%20at%2010.17.22%20PM.jpeg";
const IMG_BACK =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_badge-simulator-1/artifacts/0a9726e51a366102_IMG-20261013-WA0034.jpg";

const ease = [0.22, 1, 0.36, 1];

const CheckBadge = () => (
  <motion.svg
    data-testid="verified-check-badge"
    viewBox="0 0 32 32"
    className="h-10 w-10 sm:h-12 sm:w-12"
    initial={{ scale: 0, rotate: -30 }}
    animate={{ scale: 1, rotate: 0 }}
    transition={{ duration: 0.7, ease, delay: 0.1 }}
  >
    <motion.circle
      cx="16"
      cy="16"
      r="13.5"
      fill="none"
      stroke="#000"
      strokeWidth="2.2"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.9, ease, delay: 0.2 }}
    />
    <motion.path
      d="M9.5 16.5 14 21 22.5 11.5"
      fill="none"
      stroke="#000"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.6, ease, delay: 0.7 }}
    />
  </motion.svg>
);

const WordMark = () => (
  <header className="fixed top-0 left-0 z-20 p-6 sm:p-10">
    <div className="flex items-center gap-4">
      <CheckBadge />
      <div className="overflow-hidden pb-1">
        <motion.h1
          data-testid="verified-wordmark"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease, delay: 0.35 }}
          className="font-wordmark text-black text-3xl sm:text-5xl font-extrabold tracking-tight leading-none select-none"
        >
          Verified
          <span className="ml-1.5 align-super text-base sm:text-xl font-bold">
            *
          </span>
        </motion.h1>
      </div>
    </div>
    <motion.p
      data-testid="verified-caption"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease, delay: 0.9 }}
      className="font-mono-brand mt-5 text-[10px] sm:text-xs uppercase tracking-[0.35em] text-neutral-500 select-none"
    >
      Est. 2026 / Authenticated
    </motion.p>
  </header>
);

const Footer = () => (
  <motion.footer
    data-testid="verified-footer"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1, ease, delay: 1.2 }}
    className="fixed bottom-0 left-0 z-20 p-6 sm:p-10"
  >
    <p className="font-mono-brand text-[10px] sm:text-xs uppercase tracking-[0.35em] text-neutral-400 select-none">
      © 2026 —— VRF
    </p>
  </motion.footer>
);

const IdCard = ({ src, alt, delay, testId, y }) => (
  <motion.figure
    data-testid={testId}
    style={{ y }}
    initial={{ opacity: 0, y: 56, scale: 0.97 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ duration: 1.1, ease, delay }}
    whileHover={{ scale: 1.012 }}
    className="w-full"
  >
    <img
      src={src}
      alt={alt}
      draggable="false"
      className="w-full h-auto rounded-xl border border-black/10 shadow-[0_30px_70px_-28px_rgba(0,0,0,0.30)] transition-shadow duration-500 hover:shadow-[0_44px_100px_-28px_rgba(0,0,0,0.40)]"
    />
  </motion.figure>
);

const Home = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });
  const yFront = useTransform(scrollYProgress, [0, 1], [0, -28]);
  const yBack = useTransform(scrollYProgress, [0, 1], [0, 28]);

  return (
    <main
      data-testid="verified-page"
      className="relative min-h-screen bg-white"
    >
      <WordMark />
      <section
        ref={ref}
        className="mx-auto flex min-h-screen w-full max-w-3xl flex-col items-center justify-center gap-14 px-5 py-40 sm:gap-20 sm:py-48"
      >
        <IdCard
          src={IMG_FRONT}
          alt="Documento de identificación de muestra, frente"
          delay={0.5}
          testId="id-card-front"
          y={yFront}
        />
        <IdCard
          src={IMG_BACK}
          alt="Documento de identificación de muestra, reverso"
          delay={0.7}
          testId="id-card-back"
          y={yBack}
        />
      </section>
      <Footer />
    </main>
  );
};

function App() {
  return <Home />;
}

export default App;
